// Must be at least 1 days in the future
let earliestAvailableDate = new Date(new Date().setDate(new Date().getDate() + 1));
//Getting the current date + 1 year - RBMS does not return more than 1 year
let latestPossibleDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
let datePickerStartDate;
let datePickerEndDate;
let previousLegScheduledDate;
let nextLegScheduledDate;
let lastLegScheduledDate;
let currentLegScheduledDate;
let postDate;
let originCountryCode;
let destCountryCode;
let originZip;
let destZip;
let serviceCode;
let xhr;
let xhrTimer;

// Adding timeout to reduce the number of calls made
function getAvailableDates(datePicker, changeMonthEventArgs) {
  if (xhrTimer) {
    clearTimeout(xhrTimer);
    xhrTimer = null;
    console.log("cancelling timeout");
  }
  if (xhr) {
    xhr.abort();
    console.log("cancelling xhr call");
  }

  showLoadingMessage();

  xhrTimer = setTimeout(function() {
    callAvailability(datePicker, changeMonthEventArgs);
  }, 500);
}

function callAvailability(datePicker, changeMonthEventArgs) {
  showLoadingMessage();
  xhr = $.ajax({
    type: 'POST',
    url: '/api/sitecore/Orders/GetAvailableDates',
    contentType: 'application/json',
    dataType: 'json',
    cache: false,
    data: JSON.stringify({
      OriginCountryCode: originCountryCode,
      OriginZip: originZip,
      DestinationCountryCode: destCountryCode,
      DestinationZip: destZip,
      ReferenceDate: datePickerStartDate,
      ServiceCode: serviceCode,
    }),
    success(data) {
      const dateValue = data;
      console.log(data);
      if (dateValue && dateValue.Response) {
        let disabledDates = dateValue.Response.filter((item) => !item.IsAvailable);
        disabledDates = disabledDates.map((a) => a.DateTimeFormatted);
        window.moveLegDate = disabledDates;
        UpdateCalendarDates(datePicker, disabledDates, changeMonthEventArgs);
        console.log("Done updating calendar");
        hideLoadingMessage();
      }      
      else if (xhr.abort()){
      }
      else {
        handleDatePickerErrorResponse(data);
      }
    },
    error(data, textStatus, errorThrown) {
      if (xhr.abort())
        return;
      handleDatePickerErrorResponse(data, textStatus, errorThrown);
    }
  });
}

function handleDatePickerErrorResponse(data, textStatus, errorThrown) {
  const errorMessage = 'Error getting availability data';
  console.error(errorMessage, data, textStatus, errorThrown);
  showNotification('error', errorMessage);
  $('.selected-date-picker').datepicker('hide');
}

function showLoadingMessage() {
  $('#loadingTBody').remove();
  $('.datepicker-days tbody').hide();
  $('div.datepicker-days table').after("<div id='loadingTBody' style='width: 225px; border: 2px solid #c6cdd4; font-weight: bold; text-align: center; padding: 5px;'><tr><td colspan='7'>Loading...</td></tr></div>");
}

function hideLoadingMessage() {
  console.log("Hiding calendar loading");
    $('#loadingTBody').remove();
    $('.datepicker-days tbody').show();
}

function setDatePickerReferenceDates(datepickerTarget, changeMonthEventArgs) {  
  
  datePickerStartDate = new Date($('.datepicker-dropdown').find('.table-condensed tr td.day:first-of-type').data('date'));
  // add a few days to compensate for the fact the legacy service returns a few days
  datePickerStartDate = addDays(datePickerStartDate, +5);
  datePickerEndDate = nextLegScheduledDate != undefined ? nextLegScheduledDate : latestPossibleDate;
  // If this reference update is a result of the month being changed, use the date from the new month
  if (changeMonthEventArgs && changeMonthEventArgs.date) {
    // Get the first day of the selected month so we get availability for the whole month
    if (console.debug) console.debug("changeMonthEventArgs.date: " + changeMonthEventArgs.date);
    datePickerStartDate = new Date(changeMonthEventArgs.date.getFullYear(), changeMonthEventArgs.date.getMonth(), 1); 
  }
  // The currently referenced date cannot be before the earliest available booking date
  datePickerStartDate = earliestAvailableDate < datePickerStartDate ? datePickerStartDate : earliestAvailableDate;
  console.log("Previous leg:" + previousLegScheduledDate);
  
  // The currently referenced date cannot be before the previous move leg's scheduled date
  if (datePickerStartDate < previousLegScheduledDate && ($(datepickerTarget).closest(".component-timeline_journey-card").attr('data-legtype') != "NEW")) {
    datePickerStartDate = previousLegScheduledDate;
  }
    
  console.log("Start Date: " + datePickerStartDate);
  // If there's a scheduled leg, then we want to set a window before/after selected value
  if (currentLegScheduledDate != undefined){
    let enforceWindow = $(datepickerTarget).attr('data-disableWindow') ? true : false;
     console.log("Datepicker: "+ enforceWindow);
    console.log("currentleg: " + currentLegScheduledDate);
    let attr = $(datepickerTarget).attr('data-legreschedulingwindow');
    let datepickerWindow = (typeof attr !== 'undefined' && attr !== false  && attr > 0) ? attr : 7;  
     
    console.log("datepickerWindow: " + datepickerWindow);
    if (enforceWindow){
    let rescheduledStartDate = enforceWindow ?  addDays(currentLegScheduledDate, -datepickerWindow) : earliestAvailableDate;
    datePickerStartDate = rescheduledStartDate > earliestAvailableDate ? rescheduledStartDate : earliestAvailableDate;
    console.log("Rescheduled Start Date: " + datePickerStartDate);
    datePickerStartDate = datePickerStartDate < previousLegScheduledDate ? previousLegScheduledDate : datePickerStartDate;
    
	  console.log("After Previous Leg Start Date: " + datePickerStartDate);
    console.log("currentleg: " + currentLegScheduledDate);
    datePickerEndDate =  enforceWindow ?  addDays(currentLegScheduledDate, +datepickerWindow) : latestPossibleDate;
    if (lastLegScheduledDate != undefined){
      console.log("lastLegScheduledDate- " + lastLegScheduledDate);
      datePickerEndDate = datePickerEndDate < lastLegScheduledDate ? datePickerEndDate : lastLegScheduledDate;
    }
  }
    //console.log("Enforced last Date: " + addDays(currentLegScheduledDate, +datepickerWindow));
    //console.log("End last Date: " + datePickerEndDate);
    //console.log("Enforced start: " + addDays(currentLegScheduledDate, +datepickerWindow));
   // console.log("End start Date: " + datePickerStartDate);
  }
}

function UpdateCalendarDates(datePicker, dateArray, changeMonthEventArgs) {
  $(datePicker).datepicker('setDatesDisabled', dateArray);
  // Using schedule start/end date for first leg
  //console.log(changeMonthEventArgs);
  if ($(datePicker).closest('.component-timeline_journey-card.active').attr('data-legtype') == 'NEW') {
    const tomorrow = new Date(new Date().setDate(new Date().getDate() + 1));
    const scheduleStartDate = new Date($(datePicker).closest('.component-timeline_journey-card.active').find().attr('data-schedulingRuleStartDate'));
    // Setting start date to tomorrow if the date is in the past
    let startDate = scheduleStartDate > tomorrow ? scheduleStartDate : tomorrow;
    //startDate = datePickerStartDate > startDate ? datePickerStartDate : startDate;
    let nextDate =  new Date($(datePicker).closest('.component-timeline_journey-card.active').next().find("[data-bind^='text:legScheduledDate']").html());
    nextDate.setDate(nextDate.getDate() + -1);   
    
    let endDate = ((nextDate != undefined && nextDate != null && nextDate != "Invalid Date"))? nextDate : new Date(new Date().setFullYear(new Date().getFullYear() + 1));

    if ($(datePicker).attr('data-disablewindow')){ 
      let attr = $(datePicker).attr('data-legreschedulingwindow');
      let currentLegScheduledDate = new Date($(datePicker).closest('.component-timeline_journey-card.active').find("[data-bind^='text:legScheduledDate']").html())
      console.log("updated currentLegScheduledDate: " + currentLegScheduledDate);
      let datepickerWindow = (typeof attr !== 'undefined' && attr !== false  && attr > 0) ? attr : 7;  
      startDate =  addDays(currentLegScheduledDate, -datepickerWindow);
      endDate =  addDays(currentLegScheduledDate, +datepickerWindow);
      console.log("updated start: " + startDate);
      console.log("updated end: " + endDate);
    }
    console.log(endDate)
    
    $(datePicker).datepicker('setStartDate', startDate); 
    $(datePicker).datepicker('setEndDate', endDate); 
  }
  $(datePicker).data('datepicker').update();
  console.log("Done UpdateCalendarDates");
}

function getPreviousRawScheduledDate(currentCard) {
  let rawScheduledDate;
  let previousCard = currentCard;
  while (!rawScheduledDate && (previousCard = previousCard.prev(".component-timeline_journey-card")).length > 0) {
    rawScheduledDate = previousCard.find("[data-scheduleddate]").data('scheduleddate');
  }
  return rawScheduledDate;
}

function getPreviousScheduledDate(currentCard) {
  let previousCardDate;
  if (currentCard.prevAll(".component-timeline_journey-card.Scheduled").length > 0 && currentCard.prevAll(".component-timeline_journey-card.Scheduled").attr("data-legtype") != "PPF") {
    previousCardDate = currentCard.prevAll(".component-timeline_journey-card.Scheduled").find("[data-bind^='text:legScheduledDate']").html();
  }
  else if (currentCard.prevAll(".component-timeline_journey-card.Scheduled").length > 0 && currentCard.prevAll(".component-timeline_journey-card.Scheduled").attr("data-legtype") == "PPF" ){
    previousCardDate = currentCard.prev().prevAll(".component-timeline_journey-card.Scheduled").find("[data-bind^='text:legScheduledDate']").html();
  }
  else {
    previousCardDate = undefined;
  }
  return previousCardDate;
}

function getNextRawScheduledDate(currentCard) {
  let rawScheduledDate;
  let nextCard = currentCard;
  while (!rawScheduledDate && (nextCard = nextCard.next(".component-timeline_journey-card")).length > 0) {
    rawScheduledDate = nextCard.find("[data-scheduleddate]").data('scheduleddate');
  }
  return rawScheduledDate;
}

function getPreviousTransitDaysText(currentCard) {
  let transitDaysText;
  let previousCard = currentCard;
  while (!transitDaysText && (previousCard = previousCard.prev(".component-timeline_journey-card")).length > 0) {
    transitDaysText = previousCard.find("[data-bind^='text:legTransitDays']").html();
  }
  return transitDaysText;
}

function getAvailabilityFields(datePicker) {
  
  // Go get the scheduled date from the previous move leg
  let currentCard = $(datePicker).closest(".component-timeline_journey-card")
  // checking if it's an inline form
  if ($(datePicker).closest('.component-timeline_journey-card.active').find('.progress-content.inlineForm').find('.ZipCode').val()) {
    // using zip code field value
    originZip = $(datePicker).closest('.component-timeline_journey-card.active').find('.progress-content.inlineForm').find('.ZipCode').val();
    originCountryCode = $(datePicker).closest('.component-timeline_journey-card.active').find('.progress-content.inlineForm').find('.RegionCode').val();
    destZip = $(datePicker).closest('.component-timeline_journey-card.active').find('.progress-content.inlineForm').find('.ZipCode').val();
    destCountryCode = $(datePicker).closest('.component-timeline_journey-card.active').find('.progress-content.inlineForm').find('.RegionCode').val();
    serviceCode = $(datePicker).closest('.component-timeline_journey-card').data('legtype');
  } else {
    // using the attribute zip code
    originZip = currentCard.attr('data-legAvailabilityOriginZip');
    originCountryCode = currentCard.attr('data-legAvailabilityOriginCountry');
    destZip = currentCard.attr('data-legAvailabilityDestinationZip');
    destCountryCode = currentCard.attr('data-legAvailabilityDestinationCountry');
    serviceCode = $(datePicker).closest('.component-timeline_journey-card').data('legtype');
  }
  if (!destCountryCode) {
    destCountryCode = originCountryCode;
  }
  let rawScheduledDate = getPreviousRawScheduledDate(currentCard);
  let rawCurrentLegDate = currentCard.find("[data-scheduleddate]").data('scheduleddate');
  let rawNextLegDate = getNextRawScheduledDate(currentCard);
  //console.log("rawNextLegDate: " + rawNextLegDate);

  previousLegScheduledDate = rawScheduledDate != undefined ? new Date(rawScheduledDate) : new Date(getPreviousScheduledDate(currentCard));
  let transitDaysText = getPreviousTransitDaysText(currentCard);
  let transitDays = parseInt(transitDaysText);
  if (isNaN(transitDays)) {
    transitDays = 0;
  }
 
  // We need to add one extra day so they can't schedule it for the same day as the previous leg.
  previousLegScheduledDate.setDate(previousLegScheduledDate.getDate() + transitDays + 1);
  if (rawCurrentLegDate != undefined){    
    currentLegScheduledDate = new Date(rawCurrentLegDate);
  }
  else {
    currentLegScheduledDate = previousLegScheduledDate;
  }
  // Set up New Leg type to look for the current leg
  let isNewLeg = currentCard.attr('data-legtype') == 'NEW' ? true : false;
  
  if (isNewLeg) {
    datePickerStartDate = new Date(currentLegScheduledDate);
    datePickerStartDate = new Date(currentLegScheduledDate.getFullYear(), currentLegScheduledDate.getMonth(), 1);
    previousLegScheduledDate = new Date(earliestAvailableDate);
    nextLegScheduledDate = new Date(latestPossibleDate);
    if (currentCard.find('.datepicker').attr('data-disableWindow')){
    let attr = currentCard.find('.datepicker').attr('data-legreschedulingwindow');
    let datepickerWindow = (typeof attr !== 'undefined' && attr !== false  && attr > 0) ? attr : 7;  
     
   // console.log("New Leg datepickerWindow: " + datepickerWindow);
    let rescheduledStartDate = addDays(currentLegScheduledDate, -datepickerWindow);
    datePickerStartDate = rescheduledStartDate > earliestAvailableDate ? rescheduledStartDate : earliestAvailableDate;
   // console.log("New Leg Rescheduled Start Date: " + datePickerStartDate);
    datePickerStartDate = datePickerStartDate < previousLegScheduledDate ? previousLegScheduledDate : datePickerStartDate;
    
	 // console.log("New Leg After Previous Leg Start Date: " + datePickerStartDate);
    //console.log("New Leg currentleg: " + currentLegScheduledDate);
    datePickerEndDate =  addDays(currentLegScheduledDate, +datepickerWindow);
    if (lastLegScheduledDate != undefined){
      console.log("New Leg lastLegScheduledDate- " + lastLegScheduledDate);
      datePickerEndDate = datePickerEndDate < lastLegScheduledDate ? datePickerEndDate : lastLegScheduledDate;
    }
    }
  }
  //console.log(currentLegScheduledDate);
  // Go get the scheduled date from the next move leg, if it's scheduled
  rawScheduledDate = currentCard.next().find("[data-scheduleddate]").data('scheduleddate');
  if (rawScheduledDate) {
    nextLegScheduledDate = new Date(rawScheduledDate);
    // We need to remove one extra day so they can't schedule it for the same day as the next leg.
    nextLegScheduledDate.setDate(nextLegScheduledDate - 1);
  }
  else {
    nextLegScheduledDate = undefined;
  }
  if (rawNextLegDate){    
    lastLegScheduledDate = new Date(rawNextLegDate);
    // We need to remove one extra day so they can't schedule it for the same day as the next leg.
    lastLegScheduledDate.setDate(lastLegScheduledDate.getDate() - 1);
    //Make the next leg end date also the same as the last leg scheduled date
    if (nextLegScheduledDate == undefined || isNaN(nextLegScheduledDate))
       {
        nextLegScheduledDate = lastLegScheduledDate;
      }
  }
  else {
    lastLegScheduledDate = latestPossibleDate;
  }
  datePickerStartDate = previousLegScheduledDate;
  datePickerEndDate = nextLegScheduledDate;
}

// function validDateBtnEnabler() {
//   // Input button is disabled until a valid date has been entered
//   // When valid, the button associated becomes active
//   const btns = $('.invalid');

//   $(btns).each(function () {
//     const attr = $(this).attr('data-enable-btn');

//     $(this).on('input change', function () {
//       if ($(this).val() !== '') {
//         $(attr).removeClass('disabled');
//         $(this).addClass('valid');
//       } else {
//         $(attr).removeClass('disabled');
//       }
//     });
//   });
// };

$(document).on('click', '.datepicker.selected-date-picker', function () {
  $(this).closest('.component-timeline_journey-card').addClass('active');

  if ($(this).closest('.component-timeline_journey-card.active').find('.progress-content.inlineForm').find('.ZipCode').val() == '') {
    $(this).closest('.component-timeline_journey-card.active').find('.ZipCode').closest('.error:not(.outside-service-area)').removeClass('d-none');
    $(this).closest('body').find('.datepicker.datepicker-dropdown').remove();
  } else {
    if (!$('.baseDatepicker').length > 0) {
      var selectedDate = { date: $(this).data('current-date') };
      
        getAvailabilityFields(this);
        setDatePickerReferenceDates(this, selectedDate);
      
      callAvailability(this, null);
    }
  }
});

// This will make Edit button enable only when date is selected.
// $(window).on('load',() => {
//   $('.datepicker').datepicker().on('changeDate', () => {
//     $('.component-timeline_journey-card.active').find('.submitScheduleForm').removeClass('disabled');
//   });
// });

$(document).on('changeDate', '.datepicker', function () {
  invalidateContainerPlacement();
  resetContainerPlacementButton();

  let address = $('.component-timeline_journey-card.active').find('.AddressRequired');
  let zipCode = $('.component-timeline_journey-card.active').find('.ZipCode');

  if ($(this).val() && address.val() && zipCode.val()) {
    enableContainerPlacement(zipCode);
  } else {
    disableContainerPlacement(zipCode);
  }
});

$(document).on('changeMonth', '.datepicker', (e) => {
  if (e && e.currentTarget) {
    $(e.currentTarget).data('current-date', e.date);
    let datePicker = e.currentTarget;
    if (!$('.baseDatepicker').length > 0) {
		  setDatePickerReferenceDates(datePicker, e);
      getAvailableDates(datePicker, e);
    }
  }
});

const configureNewDatePicker = function(datePicker) {
 // console.log('Configuration........');
  getAvailabilityFields(datePicker);
  setDatePickerReferenceDates(datePicker);
  let datePickerParams = {
    format: 'mm-dd-yyyy',
    language: 'en',
    startDate: datePickerStartDate,
    defaultViewDate: datePickerStartDate,
    endDate: datePickerEndDate,
    minDate: 0,
    autoclose: !0,
    maxViewMode: 1,
    disableEntry: !0,
    updateViewDate: !1,
    orientation: 'bottom',
    daysOfWeekDisabled: "0"
  };
  
  $(datePicker).datepicker(datePickerParams);
  let year = datePickerStartDate.getFullYear();
  let month = (1 + datePickerStartDate.getMonth()).toString();
  let day = datePickerStartDate.getDate().toString();
  //console.log('datePickerStartDate' + datePickerStartDate);
  month = month.length > 1 ? month : `0${month}`;
  day = day.length > 1 ? day : `0${day}`;

  let checkDate = `${month}-${day}-${year}`;

  let dateTest = $(datePicker).val();

  if (checkDate !== dateTest) {
    $(datePicker).addClass('active');
  }

  $(datePicker).datepicker().on('changeDate', () => {
    $('.component-timeline_journey-card.active').find('.submitScheduleForm').removeClass('disabled');
  });
}

const configureNewBaseDatePicker = function(datePicker) {  
  let datePickerParams = {
    format: 'mm-dd-yyyy',
    language: 'en',
    minDate: 0,
    autoclose: !0,
    maxViewMode: 1,
    disableEntry: !0,
    updateViewDate: !1,
    orientation: 'bottom',
    daysOfWeekDisabled: "0"
  };
  
  $(datePicker).datepicker(datePickerParams);
}

const addDatePicker = function () { 
  $('.datepicker').each(function(i, datePicker) {    
    configureNewDatePicker(datePicker);
  });
};

const addBaseDatePicker = function () { 
  $('.baseDatepicker').each(function(i, datePicker) {    
    configureNewBaseDatePicker(datePicker);
  });
};

const init = function () {
  if ($('.baseDatepicker').length > 0) {
    earliestAvailableDate = new Date(new Date().setDate(new Date().getDate() - 60));
    addBaseDatePicker();
  }
  if ($('.datepicker').length > 0) {
    addDatePicker();
  }
};
//prototypes
function addDays(date, days) {
  var result = new Date(date);
  result.setDate(date.getDate() + days);
  return result;
}

if (typeof delayTimelineInit === 'undefined' || !delayTimelineInit) {
  $(init);
}
(function ($) {
  $(".component-timeline .datepicker").on('click',function(){ $(this).focus().blur();});
}(jQuery));
